import { render, staticRenderFns } from "./LinesDetailsProxy.vue?vue&type=template&id=c4b6ec44&"
import script from "./LinesDetailsProxy.vue?vue&type=script&lang=ts&"
export * from "./LinesDetailsProxy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports